// dataActions.js
import axiosInstance from "../../api/axiosInstance";
import { FETCH_REQUEST, FETCH_SUCCESS, FETCH_FAILURE } from "./actionTypes";
import { BASE_API_URL } from "../../constants";
import axios from "axios";
import { xorDecrypt } from "../../encrypt";

// Action creators for common success and failure
const fetchRequest = (entity) => ({ type: FETCH_REQUEST, entity });
const fetchSuccess = (entity, data) => ({
  type: FETCH_SUCCESS,
  entity,
  payload: data,
});
const fetchFailure = (entity, error) => ({
  type: FETCH_FAILURE,
  entity,
  payload: error,
});

// Fetch the shared link
const sharedLink = BASE_API_URL;

// Helper function to make API calls
const fetchKeywordData = async (keyword) => {
  const response = await axiosInstance.post(
    `${sharedLink}/abanotes/getnotekeyword`,
    { keyword },
    { withCredentials: true }
  );
  return response?.data.length > 0
    ? response.data[0]?.keywordValues
    : response.data;
};

// Action to fetch all dropdown data at once
export const fetchAllDropdownData = () => {
  return async (dispatch) => {
    dispatch(fetchRequest("dropdownData"));
    //console.log("Fetching dropdown data...");

    try {
      const keywords = [
        "Session Participants",
        "Place of Service",
        "Primary Target Areas",
        "Behavioral Strategies",
        "Maladaptive Behaviors",
        "Reinforcer",
        "Skill Strategies",
        "Client's Mood and Response",
        "Session Start Greetings",
        "Session End Greetings",
        "Next Session Plan",
        "BCBA Activities",
        "RBT WorkStyle",
        "Skill Strategies Applied",
        "Behavior Strategies Applied",
        "Supervision Provided",
        "Training Provided By",
        "BCBA Strategies Applied",
        "BCBA Activities Performed",
        "Session Purpose",
        "Assessment Tool Used",
      ];

      const responses = await Promise.all(keywords.map(fetchKeywordData));
      //console.log(responses);

      const [
        participants,
        placeOfServiceCode,
        primaryTargetAreas,
        behaviorInterventions,
        maladaptiveBehaviors,
        reinforcers,
        skillStrategies,
        clientMoods,
        sessionStartGreetings,
        sessionEndComments,
        nextSessionPlans,
        bcbaActivities,
        rbtWorkStyle,
        skillStrategiesApplied,
        behaviorStrategiesApplied,
        supervisionProvided,
        trainingProvidedBy,
        bcbaStrategiesApplied,
        bcbaActivitiesPerformed,
        sessionPurpose,
        assessmentToolsUsed,

      ] = responses;

      dispatch(
        fetchSuccess("dropdownData", {
          participants,
          placeOfServiceCode,
          primaryTargetAreas,
          behaviorInterventions,
          maladaptiveBehaviors,
          reinforcers,
          skillStrategies,
          clientMoods,
          sessionStartGreetings,
          sessionEndComments,
          nextSessionPlans,
          bcbaActivities,
          rbtWorkStyle,
          skillStrategiesApplied,
          behaviorStrategiesApplied,
          supervisionProvided,
          trainingProvidedBy,
          bcbaStrategiesApplied,
          bcbaActivitiesPerformed,
          sessionPurpose,
          assessmentToolsUsed,
        })
      );
    } catch (error) {
      dispatch(fetchFailure("dropdownData", error));
    }
  };
};
export const fetchClientData = () => {
  return async (dispatch) => {
    dispatch(fetchRequest("clientData"));
    const subscriberId = xorDecrypt(localStorage.getItem("subscriberId"));
    //console.log("Decrypted Subscriber ID:", subscriberId);
    try {
      const response = await axiosInstance.post(`/abanotes/getclient`, {
        subscriberid: subscriberId,
      }); // Adjust URL accordingly
      if (response.data && Array.isArray(response.data))
        dispatch(fetchSuccess("clientData", response.data));
    } catch (error) {
      dispatch(fetchFailure("clientData", error));
    }
  };
};
